export const ADD_TECH = "@techId/ADD"
